<div class="sticky-cont" *ngIf="(isPackageDetail$ | async) === false">
  <div class="search-item-cont" [class.hidden]="isLoadingHotelDetail$ | async">
    <div class="back-cont">
      <div class="back-btn" (click)="back()">
        <app-ds-icon
          [icon]="icons.ChevronLeft"
          [size]="16"
          [color]="iconFillColor.Primary">
        </app-ds-icon>
        <app-ds-typography
          [size]="fontSize.XXS"
          [tag]="'p'"
          [fontFamily]="fontFamily.SemiBold"
          [color]="fontColor.Primary"
          [text]="'BACK' | transloco">
        </app-ds-typography>
      </div>
    </div>
    <ng-container *ngIf="isPackageDetail$ | async; else hotelSearchBar">
      <app-packages-search-bar
        [showHotelDetail]="true"
        [searchType]="searchType"
        [hotelDetail]="hotelDetail$ | async"
        [source]="source">
      </app-packages-search-bar>
    </ng-container>
    <ng-template #hotelSearchBar>
      <app-hotel-search
        [showHotelDetail]="true"
        [loadSearchData]="isLoadingHotelDetail$ | async"
        [hotelDetail]="hotelDetail$ | async"
        [searchType]="searchType"
        [source]="source">
      </app-hotel-search>
    </ng-template>
  </div>
</div>
<div class="cont-detail-hotel" *ngIf="(isLoadingHotelDetail$ | async) === false; else detailPlaceholder">
  <div class="cont-gallery" (click)="toggleShowGallery()">
    <app-image-gallery-desktop [images]="(hotelDetail$ | async)?.Info?.Images">
    </app-image-gallery-desktop>
  </div>
  <div class="content-title-hotel" (click)="toggleShowGallery()">
    <div class="title-hotel">
      <app-ds-typography
        [size]="fontSize.MD"
        [tag]="'h1'"
        [fontFamily]="fontFamily.SemiBold"
        [color]="fontColor.Invert"
        [text]="(hotelDetail$ | async)?.Info?.HotelName">
      </app-ds-typography>
      <div class="stars">
        <ng-container *ngFor="let star of hotelDetail$ | async | stars">
          <app-ds-icon
            [icon]="icons.Star"
            [size]="16"
            [color]="iconFillColor.Light">
          </app-ds-icon>
        </ng-container>
      </div>
      <div class="location">
        <app-ds-icon
          [icon]="icons.Location"
          [size]="14"
          [color]="iconFillColor.Light">
        </app-ds-icon>
        <app-ds-typography
          [size]="fontSize.XXXS"
          [tag]="'p'"
          [fontFamily]="fontFamily.SemiBold"
          [color]="fontColor.Invert"
          [text]="(hotelAddress$ | async) + ' • ' + (hotelDetail$ | async)?.Info?.Zone">
        </app-ds-typography>
      </div>
    </div>
  </div>
  <div class="container-detail">
    <app-hotel-description-desktop 
      [hotel]="hotelDetail$ | async" 
      [hotelDetailParams]="params$ | async" 
      [isLoggedIn]="isLoggedIn"
      [hotelAmenities]="hotelAmmenities" 
      [detailSticky]="detailSticky" 
      [hasRappiCard]="hasRappiCard" 
      [isPrime]="isPrime"
      [provider]="(hotelDetail$ | async)?.Result?.HotelProvider" 
      (openMap)="toggleMap()"
      (toggleShowGallery)="toggleShowGallery()">
    </app-hotel-description-desktop>
  </div>
</div>

<div class="modal" [ngClass]="{'open': showMap}">
  <div class="cont-map">
    <div class="icon-close" (click)="toggleMap()"></div>
    <app-map [markers]="hotelMarkers$ | async"></app-map>
  </div>
  <div class="mask" (click)="toggleMap()"></div>
</div>

<ng-template #desktopPlaceholder>
  <div class="hotel-detail-placeholder-container">
    <div class="image-desktop"></div>
    <div class="content-placeholder-desktop">
      <div class="floating-info"></div>
      <div class="hotel-info"></div>
      <div class="amenities"></div>
      <div class="location"></div>
      <div class="hab-title"></div>
    </div>
  </div>
</ng-template>

<ng-template #detailPlaceholder>
  <ng-container [ngTemplateOutlet]="desktopPlaceholder"></ng-container>
</ng-template>

<app-modal-gallery [images]="(hotelDetail$ | async)?.Info?.Images"></app-modal-gallery>
